module.exports = __webpack_public_path__ + "img/signup-guide-03-05.2525f7fd.png";